import api from './api';
import { normalizePlayerUrl } from './storage/playerVideo';

function authHeaders(accessToken) {
    return {
        Authorization: `Bearer ${accessToken}`,
    };
}

export default {
    /**
     * Preview do gestor/admin.
     * GET /file/videoteca/player/{id}
     */
    async getFrameVideoteca(accessToken, id) {
        try {
            const response = await api.get(`/file/videoteca/player/${id}`, {
                headers: authHeaders(accessToken),
            });
            return normalizePlayerUrl(response.data);
        } catch (error) {
            console.error('Erro ao obter frame do usuário:', error);
            throw error;
        }
    },
};
